// removed by extract-text-webpack-plugin
module.exports = {"root":"LoadingSpinner_root_e1k","sk-folding-cube":"LoadingSpinner_sk-folding-cube_32G","sk-cube":"LoadingSpinner_sk-cube_5p2","sk-foldCubeAngle":"LoadingSpinner_sk-foldCubeAngle_1C5","sk-cube2":"LoadingSpinner_sk-cube2_2TI","sk-cube3":"LoadingSpinner_sk-cube3_39V","sk-cube4":"LoadingSpinner_sk-cube4_1bd"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/LoadingSpinner/LoadingSpinner.css
 ** module id = 576
 ** module chunks = 0
 **/